import { CheckboxValue } from "./Checkbox";

export const CheckboxTestPageObject = (
    value: CheckboxValue,
    checkedValue: CheckboxValue,
    handleChange: (checked?: boolean) => void
) => ({
    getType: () => "Checkbox",

    isChecked: (): boolean => value === checkedValue,

    setChecked: handleChange,
});
